import React from 'react'
import Footer from "../../Footer/Footer";
import "./VoteOver.scss";
const VoteOver = () => {
    return (
        <div className="vote-over">
            <div className="top"></div>
            <div className="bottom"></div>
            <div className="text-wrapper">
                <h1>ההצבעה הסתיימה</h1>
                <h2>ניפגש במשדר מיוחד בהגשת דלית רצ'שטר, שיועבר בשידור חי ב-
                    <span>
                    {" ynet "}
                    </span>
                     ובגלגלצ
                    <br />
                    ב-31 בדצמבר בין השעות 14:00-18:00
                </h2>
            </div>
            <Footer break1024="true"/>
        </div>
    )
}

export default VoteOver
